const storiesTypes = {
    LEVIA: 'LEVIA',
    HIGHLIGHTS: 'HIGHLIGHTS',
    HIGHLIGHTS_AND_QUIZ: 'HIGHLIGHTS_AND_QUIZ',
    MOST_POPULAR_FLAVOURS: 'MOST_POPULAR_FLAVOURS',
    HOW_TO_USE_STORIES: 'HOW_TO_USE_STORIES',
    MANAGE_EXPECTATIONS: 'MANAGE_EXPECTATIONS',
    TASTE_DISCOVERY: 'TASTE_DISCOVERY',
    EXCLUSIVE_USAGE: 'EXCLUSIVE_USAGE',
    SUPERIORITY_CONVENIENCE: 'SUPERIORITY_CONVENIENCE',
    FIND_PLEASURE: 'FIND_PLEASURE',
    COMMUNITY: 'COMMUNITY',
    MOTIVATION: 'MOTIVATION',
    ADVANCED_FEATURES: 'ADVANCED_FEATURES',
    SERVICES_AND_PRIVILEGES: 'SERVICES_AND_PRIVILEGES',
    TIPS_AND_TRICKS: 'TIPS_AND_TRICKS',
    SATISFACTION: 'SATISFACTION',
};

export default storiesTypes;
